import { useEffect, useState } from 'react';
import { offerDurationHours } from '../data/kit';

const STORAGE_KEY = 'kgpo-offer-deadline';
const DURATION_MS = offerDurationHours * 60 * 60 * 1000;

function getDeadline(): number {
  const now = Date.now();
  try {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));
    if (stored && stored > now) return stored;
    const next = now + DURATION_MS;
    window.localStorage.setItem(STORAGE_KEY, String(next));
    return next;
  } catch {
    return now + DURATION_MS;
  }
}

export interface Countdown {
  hours: string;
  minutes: string;
  seconds: string;
}

function format(ms: number): Countdown {
  const total = Math.max(0, Math.floor(ms / 1000));
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    hours: pad(Math.floor(total / 3600)),
    minutes: pad(Math.floor((total % 3600) / 60)),
    seconds: pad(total % 60),
  };
}

export function useOfferCountdown(): Countdown {
  const [deadline, setDeadline] = useState<number>(() => getDeadline());
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => {
      const current = Date.now();
      setNow(current);
      if (current >= deadline) setDeadline(getDeadline());
    }, 1000);
    return () => window.clearInterval(id);
  }, [deadline]);

  return format(deadline - now);
}
